import * as React from "react";
const GraphIcon = (props) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28.8931 9.2667C28.0397 6.37337 25.6264 3.96003 22.7331 3.1067C20.5331 2.4667 19.0131 2.52003 17.9597 3.3067C16.6931 4.25337 16.5464 5.96003 16.5464 7.17337V10.4934C16.5464 13.7734 18.0397 15.44 20.9731 15.44H24.7997C25.9997 15.44 27.7197 15.2934 28.6664 14.0267C29.4797 12.9867 29.5464 11.4667 28.8931 9.2667Z"
      fill="#344054"
    />
    <path
      d="M28.8931 9.2667C28.0397 6.37337 25.6264 3.96003 22.7331 3.1067C20.5331 2.4667 19.0131 2.52003 17.9597 3.3067C16.6931 4.25337 16.5464 5.96003 16.5464 7.17337V10.4934C16.5464 13.7734 18.0397 15.44 20.9731 15.44H24.7997C25.9997 15.44 27.7197 15.2934 28.6664 14.0267C29.4797 12.9867 29.5464 11.4667 28.8931 9.2667Z"
      fill="url(#paint0_linear_3639_300858)"
    />
    <path
      d="M28.8931 9.2667C28.0397 6.37337 25.6264 3.96003 22.7331 3.1067C20.5331 2.4667 19.0131 2.52003 17.9597 3.3067C16.6931 4.25337 16.5464 5.96003 16.5464 7.17337V10.4934C16.5464 13.7734 18.0397 15.44 20.9731 15.44H24.7997C25.9997 15.44 27.7197 15.2934 28.6664 14.0267C29.4797 12.9867 29.5464 11.4667 28.8931 9.2667Z"
      fill="url(#paint1_linear_3639_300858)"
    />
    <g opacity={0.4}>
      <path
        d="M25.2132 17.8135C24.8665 17.4135 24.3599 17.1869 23.8399 17.1869H19.0665C16.7199 17.1869 14.8132 15.2802 14.8132 12.9335V8.1602C14.8132 7.6402 14.5865 7.13353 14.1865 6.78687C13.7999 6.4402 13.2665 6.2802 12.7599 6.34687C9.62653 6.74687 6.74653 8.46687 4.86653 11.0535C2.9732 13.6535 2.27986 16.8269 2.87986 20.0002C3.74653 24.5869 7.4132 28.2535 12.0132 29.1202C12.7465 29.2669 13.4799 29.3335 14.2132 29.3335C16.6265 29.3335 18.9599 28.5869 20.9465 27.1335C23.5332 25.2535 25.2532 22.3735 25.6532 19.2402C25.7199 18.7202 25.5599 18.2002 25.2132 17.8135Z"
        fill="#344054"
      />
      <path
        d="M25.2132 17.8135C24.8665 17.4135 24.3599 17.1869 23.8399 17.1869H19.0665C16.7199 17.1869 14.8132 15.2802 14.8132 12.9335V8.1602C14.8132 7.6402 14.5865 7.13353 14.1865 6.78687C13.7999 6.4402 13.2665 6.2802 12.7599 6.34687C9.62653 6.74687 6.74653 8.46687 4.86653 11.0535C2.9732 13.6535 2.27986 16.8269 2.87986 20.0002C3.74653 24.5869 7.4132 28.2535 12.0132 29.1202C12.7465 29.2669 13.4799 29.3335 14.2132 29.3335C16.6265 29.3335 18.9599 28.5869 20.9465 27.1335C23.5332 25.2535 25.2532 22.3735 25.6532 19.2402C25.7199 18.7202 25.5599 18.2002 25.2132 17.8135Z"
        fill="url(#paint2_linear_3639_300858)"
      />
      <path
        d="M25.2132 17.8135C24.8665 17.4135 24.3599 17.1869 23.8399 17.1869H19.0665C16.7199 17.1869 14.8132 15.2802 14.8132 12.9335V8.1602C14.8132 7.6402 14.5865 7.13353 14.1865 6.78687C13.7999 6.4402 13.2665 6.2802 12.7599 6.34687C9.62653 6.74687 6.74653 8.46687 4.86653 11.0535C2.9732 13.6535 2.27986 16.8269 2.87986 20.0002C3.74653 24.5869 7.4132 28.2535 12.0132 29.1202C12.7465 29.2669 13.4799 29.3335 14.2132 29.3335C16.6265 29.3335 18.9599 28.5869 20.9465 27.1335C23.5332 25.2535 25.2532 22.3735 25.6532 19.2402C25.7199 18.7202 25.5599 18.2002 25.2132 17.8135Z"
        fill="url(#paint3_linear_3639_300858)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3639_300858"
        x1={16.5464}
        y1={2.66748}
        x2={29.3189}
        y2={15.4563}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CE9FFC" />
        <stop offset={1} stopColor="#7367F0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3639_300858"
        x1={16.5462}
        y1={15.44}
        x2={29.3188}
        y2={2.65105}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7A00" />
        <stop offset={1} stopColor="#FFD439" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3639_300858"
        x1={2.66992}
        y1={6.33203}
        x2={25.6714}
        y2={29.3301}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CE9FFC" />
        <stop offset={1} stopColor="#7367F0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3639_300858"
        x1={2.66956}
        y1={29.3334}
        x2={25.6711}
        y2={6.33514}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF7A00" />
        <stop offset={1} stopColor="#FFD439" />
      </linearGradient>
    </defs>
  </svg>
);
export default GraphIcon;
